import React, { useState, useEffect } from "react";
import "./Forget_password.css";
import AppLayout from "../../../layout/AppLayout";
import { FaMobileAlt, FaEnvelope } from "react-icons/fa";
import { Button, Form } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import Phone_Number_Reset from "./Phone_Number_Reset/Phone_Number_Reset";
import Email_Reset from "./Email_Reset/Email_Reset";
import Login_Header from "../../Common/Common_Component/Login_Header/Login_Header";
import Successfull_strip_modal from "../../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { AuthForgotPassword } from "../../../features/auth/Slice";

const Forget_password = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState(location.state?.activeTab || "phone");
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("Password Reset Successfully!");

  const {
    control,
    register,
    resetField,
    handleSubmit,
    setValue, watch,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      contact_no: "",
      email: "",
      password: "",
      confirm_password: "",
    },
  });

  const showCss =
    (activeTab === "phone" ? watch("contact_no") : watch("email")) &&
    watch("password");

  // Clear opposite tab's field on tab switch
  useEffect(() => {
    if (activeTab === "phone") {
      resetField("email");
    } else {
      resetField("contact_no");
    }
  }, [activeTab]);

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("type", activeTab);
      formData.append("password", data?.password);
      formData.append("confirm_password", data?.confirm_password);

      if (activeTab === "phone") {
        formData.append("contact_no", data?.contact_no);
      } else {
        formData.append("email", data?.email);
      }

      console.log({ data });


      const res = await dispatch(AuthForgotPassword(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        setModalMessage(res?.payload?.data || "Password Reset Successfully!");
        setModalShow(true);
        setTimeout(() => {
          setModalShow(false);
          navigate(-1)
        }, 3000);
      } else if (res.meta?.requestStatus === "rejected") {
        setModalMessage(res?.payload?.errors || "Reset failed. Please try again.");
        setModalShow(true);
        setTimeout(() => {
          setModalShow(false);
        }, 3000);
      }
    } catch (error) {
      console.error("Forgot password failed:", error);
    }
  };

  return (
    <>
      <div className="login-page SignUp Forget_password">
        {/* Header */}
        <Login_Header
          title="Forget password"
          subTitle="Please retrieve/change your password through your mobile phone number or email"
        />

        {/* Body */}
        <div className="login-body">

          {/* Tabs */}
          {/* <div className="login-tabs">
            <div
              className={`tab ${activeTab === "phone" ? "active" : ""}`}
              onClick={() => setActiveTab("phone")}
            >
              <div>
                <FaMobileAlt />
              </div>
              Phone Number
            </div>

            <div
              className={`tab ${activeTab === "email" ? "active" : ""}`}
              onClick={() => setActiveTab("email")}
            >
              <div>
                <FaEnvelope />
              </div>
              Email
            </div>
          </div> */}

          <Form onSubmit={handleSubmit(onSubmit)} noValidate>

            {/* Fields change based on activeTab */}
            {activeTab === "phone" ? (
              <Phone_Number_Reset
                control={control}
                register={register}
                errors={errors}
                watch={watch}
                setValue={setValue}

              />
            ) : (
              <Email_Reset
                register={register}
                errors={errors}
                watch={watch}
                setValue={setValue}

              />
            )}

            {/* Privacy Agreement */}
            <div className="privacy_check mb-3">
              <Form.Check
                type="checkbox"
                label={
                  <>
                    I have read and agree{" "}
                    <span className="privacy_link">[Privacy Agreement]</span>
                  </>
                }
                {...register("privacyAgreement", {
                  required: "You must agree to the Privacy Agreement",
                })}
              />
              {errors.privacyAgreement && (
                <small className="text-danger">
                  {errors.privacyAgreement.message}
                </small>
              )}
            </div>

            {/* Button */}
            <Button
              type="submit"
              className={showCss ? "btn_register_bg mb-3" : "btn-login mb-3"}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Resetting..." : "Reset"}
            </Button>
          </Form>
        </div>
      </div>

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </>
  );
};

export default Forget_password;